module.exports = __webpack_public_path__ + "static/media/bannerBlackoutHomeLarge.32e1e512.jpg";